import React, { Component } from 'react';
import {
    WithStyles, createStyles, Typography, Button, Grid
} from '@material-ui/core';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withStyles } from '@material-ui/core/styles';
import { videoActions } from '../../../reducers/videoCreateContentReducers';
import { MyPATLink } from '../../../../common';
import contentService from '../../../../mylibrary/services/contentService';
import getDefaultFormData from '../../../../mylibrary/types/ContentFromDataDefault';

const styles = (theme: Theme) => createStyles({
    checkImage: {
        margin: '20px auto 20px',
        display: 'block',
    }
});

interface PublishVideoFinishModalProps extends WithStyles<typeof styles> {
    classes: any,
    resetVideoModalState: Function,
    contentId: any,
}

interface PublishVideoFinishModalState {
}

class PublishVideoFinishModal extends Component<PublishVideoFinishModalProps, PublishVideoFinishModalState> {
    constructor(props: PublishVideoFinishModalProps) {
        super(props);
        this.state = {
        }
    }

    createAnother = () => {
        let defaultFromData = getDefaultFormData();
        let typeToSend = 'audios';
        if (!window.location.pathname.includes('audios')){
            typeToSend = 'videos';
        }

        contentService.save('', typeToSend, defaultFromData, false)
        .then((res: any) => {
            let id = res.responseObject.audio && res.responseObject.audio._id || res.responseObject.video && res.responseObject.video._id;
            const location = `/content/edit/studymaterial/${typeToSend}/${id}${typeToSend}`
            window.location.replace(location);
        })
    }

    render() {
        const {
            classes,
            resetVideoModalState,
            contentId,
        } = this.props;
        return (
            <>
                <img src="/assets/img/mylibrary/publish.png" className={classes.checkImage} />
                <Typography variant="title" align="center">Content Published Successfully</Typography>
                <Typography variant="subheading" align="center">{`Congratulations! The ${window.location.pathname.includes('audios') ? 'Audio' : 'Video'} ${contentId}  is published successfully.`}</Typography>
                <Typography align="center" component="div" style={{ marginTop: '10px', marginBottom: '20px' }}></Typography>

                <Grid container xs={12} justify="center" direction="row" spacing={8}>
                    <Grid item>
                        <Button variant="contained" color="primary" onClick={() => this.createAnother()}>Create another</Button>
                    </Grid>
                    <Grid item >
                        <MyPATLink to={'/mylibrary'}>
                            <Button variant="outlined" color="primary" onClick={() => resetVideoModalState()}>Back to My Library</Button>
                        </MyPATLink>
                    </Grid>
                </Grid>


            </>

        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        publishProgressComplete: state.videoCreateContent.publishProgressComplete,
    }
};

const mapDispatchToProps = (dispatch: any) => bindActionCreators({
    resetVideoModalState: videoActions.resetVideoModalState,
}, dispatch);
// @ts-ignore
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(PublishVideoFinishModal));